module.exports = __webpack_public_path__ + "media/images/new/filter_by_elevation_laptop-476757212c5f37b27a29992d4d0f5f9c.png";